module.exports = __webpack_public_path__ + "static/media/image.62c3ef35.svg";